import RechargeCreditCardView from "./view";
import { useNavigate } from "react-router-dom";
import { ReducersTypes } from "@/redux/reducers/Models";
import { useSelector } from "react-redux";
import { PAYMENT_TYPE } from "@/redux/ducks/customer";
import useCreditCardForm from "../hooks/useCreditCardForm";
import { useSingleFlag } from "@/hooks/useFlags";

export default function RechargeCreditCard() {

  const navigate = useNavigate();
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);
  const { isEnabled: isAutoPaymentEnabled } = useSingleFlag('PD_COBRANCA_DIRETA');

  const {
    toggleModal,
    isVisibleModal,
    isLoading,
    isDisabled,
    register,
    handleSubmit,
    error,
    errorChangeMethod,
    errors,
    isVisibleConfirmationModal,
    handleConfirmAutoPayment,
    handleCancelAutoPayment,
    handleAutoPaymentChange,
    watch,
    attemptCount,
    resetAttemptCount,
  } = useCreditCardForm({navigate, isAutoPaymentEnabled});

  const goBack = () => {
    if (customer?.account?.paymentType === PAYMENT_TYPE.IS_CARD) {
      navigate('/payment/card');
      return;
    }
    navigate('/payment');
  }

  const goPaymentOptions = () => navigate('/payment');

  const goToFinished = () => navigate("/payment/finished");

  return (
    <RechargeCreditCardView
      isLoading={isLoading}
      goBack={goBack}
      isDisabled={isDisabled}
      error={error}
      errorChangePaymentMethod={errorChangeMethod}
      goToFinished={goToFinished}
      register={register}
      handleSubmit={handleSubmit}
      errors={errors}
      isVisibleModal={isVisibleModal}
      toggleModal={toggleModal}
      isVisibleConfirmationModal={isVisibleConfirmationModal}
      handleConfirmAutoPayment={handleConfirmAutoPayment}
      handleCancelAutoPayment={handleCancelAutoPayment}
      handleAutoPaymentChange={handleAutoPaymentChange}
      customer={customer}
      watch={watch}
      isAutoPaymentEnabled={isAutoPaymentEnabled}
      attemptCount={attemptCount}
      resetAttemptCount={resetAttemptCount}
      goPaymentOptions={goPaymentOptions}
    />
  );
}
